import { ISport } from 'bets.oddprovider.lib.common.ts/models'
import { NumberUtils } from 'fwork-jsts-common/src'
import { ApiClientUtils } from 'fwork-jsts-common/src/apiClient'
import { FilterQuery } from 'mongoose'
import { useSnackbar } from 'notistack'
import * as React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { DEFAULTGAP, RoutesNames } from '../../globals'
import { toggleLoading } from '../../redux/reducers/loadingBar.slice'
import { ISportsState, sportsStateLoadFromApi } from '../../redux/reducers/sports.slice'
import { RootState } from '../../redux/store'
import { HeaderComponent } from '../common/header'
import { SearchInputComponent } from '../common/searchInput'
// import { TableComponent } from '../common/table'
// import { StyledListItemText, StyledTableCell, TableComponentClickRowProps, TableComponentSetCurrPageProps } from '../common/table/common'
import { StyledListItemText, StyledTableCell, TableComponent, TableComponentSetCurrPageProps } from 'fwork.react.apptemplate'

export const SportsComponent = () => {
  const tableComponentSetCurrPageRef = React.useRef<TableComponentSetCurrPageProps>(() => { });
  const tableComponentSetCurrPage = tableComponentSetCurrPageRef.current

  const sportsState: ISportsState = useSelector((state: RootState) => state.sportsState)
  const sports = [...sportsState.payload || []]
  const navigate = useNavigate()
  const dispatch = useDispatch<any>()
  const { enqueueSnackbar } = useSnackbar()
  const [searchText, setSearchText] = useState<string | undefined>()

  const loadSports = async () => {
    dispatch(toggleLoading())
    const where: FilterQuery<ISport> | undefined = searchText ? {
      $or: [
        {
          name: { $regex: searchText, $options: 'i' },
        },
        {
          id: NumberUtils.onlyNumbers(searchText)
        }]
    } : undefined

    const response = await dispatch(sportsStateLoadFromApi({
      where,
      onFinally: () => {
        dispatch(toggleLoading())

        if (tableComponentSetCurrPage)
          tableComponentSetCurrPage({
            page: 0
          })
      },
      onError: (msg) => {
        enqueueSnackbar(ApiClientUtils.getErrorMessage(msg), { variant: 'error' })
      }
    }))

    if (!response.payload?.data?.payload?.length) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage('Nenhum registro encontrado'), { variant: 'warning' })
    }
  }

  return <>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      paddingBottom: DEFAULTGAP
    }}>
      <HeaderComponent
        props={{
          style: {
            paddingInline: DEFAULTGAP
          }
        }}
        title='Esportes'
        onRefreshClick={loadSports}
        onAddClick={() => navigate(RoutesNames.sport)}
      />

      <SearchInputComponent
        style={{
          marginInline: DEFAULTGAP,
          maxWidth: 500
        }}
        label='Pesquisar por código ou nome'
        onChange={e => setSearchText(e.target.value)}
        onKeyUp={e => { if (e.key === "Enter") loadSports() }}
        onIconClick={loadSports}
      />

      <TableComponent
        wrapperProps={{ style: { padding: DEFAULTGAP, maxWidth: 'calc(100% - 10px)' } }}
        setCurrPageRef={tableComponentSetCurrPageRef}
        bodyList={sports}
        bodyRowBuilder={(sport: ISport) => <StyledTableCell>
          <StyledListItemText
            primary={sport.name}
            secondary={sport.id}
          />
        </StyledTableCell>}
        rowProps={{
          onClickGetItem: (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>, item: ISport) => {
            navigate(RoutesNames.sport.replace(':id', item?.id.toString()))
          }
        }}
      />
    </div>
  </>
}